import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, debounceTime, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TRN_PERMISSIONS_SET_FETCH = 'TRN_PERMISSIONS_SET_FETCH'
export const TRN_PERMISSIONS_SET_FETCH_CANCELED = 'TRN_PERMISSIONS_SET_FETCH_CANCELED'
export const TRN_PERMISSIONS_SET_FETCH_ERROR = 'TRN_PERMISSIONS_SET_FETCH_ERROR'
export const TRN_PERMISSIONS_SET_FETCH_FULFILLED = 'TRN_PERMISSIONS_SET_FETCH_FULFILLED'

export const permissionsSetFetch = (entityId, userId, level, type = null) => ({
  payload: { entityId, level, type, userId },
  type: TRN_PERMISSIONS_SET_FETCH,
})

export const permissionsSetFetchFulfilled = (payload) => ({
  payload,
  type: TRN_PERMISSIONS_SET_FETCH_FULFILLED,
})

export const permissionsSetFetchCanceled = () => ({
  payload: null,
  type: TRN_PERMISSIONS_SET_FETCH_CANCELED,
})

export const permissionsSetFetchError = (payload) => ({
  payload,
  type: TRN_PERMISSIONS_SET_FETCH_ERROR,
})

export const permissionsSetFetchEpic = (action$) =>
  action$.pipe(
    ofType(TRN_PERMISSIONS_SET_FETCH),
    debounceTime(2000), // wait for 2 seconds before change your main
    mergeMap((action) =>
      epicServerRequest('post', `${APP.api_url}/permissions/${action.payload.entityId}`, action, action.payload).pipe(
        map(epicResponseHandler(permissionsSetFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TRN_PERMISSIONS_SET_FETCH, TRN_PERMISSIONS_SET_FETCH_CANCELED))),
        catchError(epicErrorHandler(permissionsSetFetchError, action)),
      ),
    ),
  )
